import { VCard } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{staticClass:"preloader",attrs:{"color":"graylight"}},[_c('div',{staticClass:"preloader-brand"}),(_vm.title)?_c('div',{staticClass:"preloader-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.subtitle)?_c('div',{staticClass:"preloader-message"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e(),_c('div',{staticClass:"text-center"},[_c(VProgressCircular,{attrs:{"size":24,"width":2,"color":"primary","indeterminate":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }